/* eslint-disable
    default-case,
    one-var,
    prefer-const
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate from 'immutability-helper';
import _ from 'underscore';

import AppDispatcher from 'lib/Dispatcher';
import {EventConstants} from 'constants/EventConstants';
import Store from 'lib/Store';
import VersionedItemSubstore from 'notebook/store/VersionedItemSubstore';
import ProtocolStoreTransforms from 'notebook/protocols/ProtocolStoreTransforms';
import notifications from 'notifications';
import {assert} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import {createNoteRuntimeSnapshot} from 'notebook/tables/TableStoreTransforms';
import ProtocolUpdater from '../ProtocolUpdater';

// Store for a collection of Protocols
class EditorStore extends Store {
  postSanitizeItem(id, newProtocol, oldProtocol, {bumpVersion}) {
    // TODO(BNCH-30610): Remove this edge case once persist eval has been fully rolled out (when ELN_ENABLE_RUNTIME_SNAPSHOT_EVAL will always be true)
    if (!BenchlingConfig.ELN_ENABLE_RUNTIME_SNAPSHOT_EVAL) {
      // If Excess Version is null we can no-op since it signifies an empty NRS
      if (newProtocol.noteRuntimeSnapshot.excessVersion == null) {
        return newProtocol;
      }
      const emptySnapshot = createNoteRuntimeSnapshot();
      return {
        ...newProtocol,
        noteRuntimeSnapshot: emptySnapshot,
      };
    }

    const updater = new ProtocolUpdater(
      id,
      () => this.itemSubstore.getItem(id),
      (protocolVersion, _asyncMultidocTableOp) => {
        const EditorActions = require('notebook/protocols/actions/EditorActions').default;
        EditorActions.update(id, {$merge: protocolVersion}, {bumpVersion}); // TODO(BNCH-137948): Table op support
      }
    );
    return updater.run(newProtocol, oldProtocol);
  }

  resetState() {
    if (this.itemSubstore == null) {
      this.itemSubstore = new VersionedItemSubstore({
        options: {
          idKey: 'protocolID',
          itemKey: 'protocol',
          friendlyItemName: 'protocol',
          asyncItemLoad: true,
          sanitizeItem: ProtocolStoreTransforms.sanitizeProtocol,
          postSanitizeItem: this.postSanitizeItem.bind(this),
          prepareForStore: ProtocolStoreTransforms.prepareForStore,
          pickRevertableFields: ProtocolStoreTransforms.pickRevertableFields,
          doSave(id) {
            const EditorActions = require('notebook/protocols/actions/EditorActions').default;
            return EditorActions.save(id);
          },
        },
        events: {
          item: {
            load: {
              init: EventConstants.EDITOR_OPEN,
              completed: EventConstants.EDITOR_OPEN_COMPLETED,
              failed: EventConstants.EDITOR_OPEN_FAILED,
            },
            close: EventConstants.EDITOR_CLOSE,
            rename: EventConstants.FILE_BROWSER_RENAME_FILE,
            revert: EventConstants.EDITOR_REPLACE,
            update: EventConstants.EDITOR_UPDATE,
            registerObjects: EventConstants.EDITOR_REGISTER_OBJECTS,
            resetToOpenVersion: EventConstants.EDITOR_RESET_TO_OPEN_VERSION,
            save: {
              init: EventConstants.EDITOR_SAVE,
              completed: EventConstants.EDITOR_SAVE_COMPLETED,
              failed: EventConstants.EDITOR_SAVE_FAILED,
            },
            move: EventConstants.FILE_BROWSER_MOVE_FILES_COMPLETED,
          },
          version: {
            load: {
              init: EventConstants.EDITOR_LOAD_VERSION,
              completed: EventConstants.EDITOR_LOAD_VERSION_COMPLETED,
              failed: EventConstants.EDITOR_LOAD_VERSION_FAILED,
            },
          },
          versions: {
            fetch: {
              init: EventConstants.EDITOR_FETCH_VERSIONS,
              completed: EventConstants.EDITOR_FETCH_VERSIONS_COMPLETED,
              failed: EventConstants.EDITOR_FETCH_VERSIONS_FAILED,
            },
          },
        },
      });
    }
    this.itemSubstore.resetState();
  }

  prepareForSave(id, protocol) {
    const {cidIdMap} = this.itemSubstore.getItemState(id);
    return ProtocolStoreTransforms.prepareForSave(protocol, cidIdMap);
  }

  getEditorState(id) {
    return this.itemSubstore.getEditorState(id);
  }

  getVersionState(id) {
    return this.itemSubstore.getVersionState(id);
  }

  getIdFromCid(id, cid) {
    return this.itemSubstore.getItemIdFromCid(id, cid);
  }

  hasUnsavedChanges(id) {
    return this.itemSubstore.hasUnsavedChanges(id);
  }

  payloadHandler(action) {
    let error, newSteps, protocol, protocolID, stepID;
    let step;
    let shouldEmit = this.itemSubstore.handlePayload(action);

    switch (action.actionType) {
      case EventConstants.EXCESS_DELETE_SNAPSHOTTED_RESOLUTIONS_FOR_TABLE: {
        const {itemId} = action;
        if (!this.itemSubstore.inStore(itemId)) {
          break;
        }
        assert(false, 'Protocol unexpectedly called refresh tables');
        break;
      }
      // For both old editor and new editor
      case EventConstants.PROTOCOL_UPDATE_COMPLETED: {
        // PROTOCOL_UPDATE is not optimistic, so we merge in the changes now.
        let {data, serverData} = action;
        if (!this.itemSubstore.inStore(protocolID)) {
          break;
        }
        const newData = _.chain(data)
          .omit('folder_id') // data.folder is already present
          .extend(serverData) // Merge in folder/editURL changes
          .value();
        this.itemSubstore.mergeItem(protocolID, newData);
        shouldEmit = true;
        break;
      }

      case EventConstants.PROTOCOL_DELETE_FAILED:
        ({protocolID, error} = action);
        if (this.itemSubstore.inStore(protocolID)) {
          notifications.notifyError(error);
        }
        break;

      case EventConstants.PROTOCOL_STEP_COMPLETE_COMPLETED:
        ({protocolID, stepID} = action);
        if (this.itemSubstore.inStore(protocolID)) {
          ({protocol} = this.itemSubstore.getItemState(protocolID));
          newSteps = (() => {
            const result = [];
            for (step of Array.from(protocol.steps)) {
              if (stepID !== step.id) {
                result.push(step);
              } else {
                result.push(reactUpdate(step, {$merge: {completed: true}}));
              }
            }
            return result;
          })();
          this.itemSubstore.mergeItem(protocolID, {steps: newSteps});
          shouldEmit = true;
        }
        break;

      case EventConstants.PROTOCOL_STEP_RESET_COMPLETED:
        ({protocolID, stepID} = action);
        if (this.itemSubstore.inStore(protocolID)) {
          ({protocol} = this.itemSubstore.getItemState(protocolID));
          newSteps = (() => {
            const result1 = [];
            for (step of Array.from(protocol.steps)) {
              if (stepID !== step.id) {
                result1.push(step);
              } else {
                result1.push(reactUpdate(step, {$merge: {completed: false}}));
              }
            }
            return result1;
          })();
          this.itemSubstore.mergeItem(protocolID, {steps: newSteps});
          shouldEmit = true;
        }
        break;
    }

    if (shouldEmit) {
      this.emitChange();
    }
    return true;
  }

  __serverBootstrapItem(object) {
    return this.itemSubstore.__serverBootstrapItem(object);
  }
}

const editorStore = new EditorStore(AppDispatcher);

export default editorStore;
